// extracted by mini-css-extract-plugin
export default {"container":"Report-container","itemIdText":"Report-itemIdText","flaggingText":"Report-flaggingText"};